<template>
    <label :class="filterValueClassName">
        <input type="checkbox" 
               v-on:click="applyFilter" 
               :checked="isChecked" /> <div :title="displayFilterValue">{{ displayFilterValue|truncate(30) }}</div> <span class="badge badge-dark badge-facet-count">{{ filterData.doc_count }}</span>
    </label>
</template>

<script>
    export default {
        props: {
            referrerUrl: { type: String, required: true },
            filterFieldName: { type: String, required: true },
            filterData: { type: Object, required: true },
            isChecked: { type: Boolean, required: true, default: false },
            translateValues: { type: Boolean, required: false, default: false }
        },

        methods: {
            applyFilter() {
                window.location = this.filterUrl;
            }
        },

        computed: {
            displayFilterValue() {
                var displayValue = '[not specified]';
                if(this.filterData.key !== '') {
                    displayValue = this.translateValues ? this.translate('label.filters.value.' + this.filterData.key) : this.filterData.key;
                }
                return displayValue;
            },

            filterUrl() {
                if (this.isChecked) {
                    // remove the selected filter parameter from the referrer url
                    return this.referrerUrl.replace('&selectedFilters' + encodeURI('[' + this.filterFieldName + '][0]=') + encodeURIComponent(this.filterData.key), '');
                } else {
                    // append the selected filter parameter to the referrer url
                    return this.referrerUrl + '&selectedFilters' + encodeURI('[' + this.filterFieldName + '][0]=' + this.filterData.key);
                }
            },

            filterValueClassName() {
                // use filterData.key as class name if it is a String consisting of one word
                return typeof this.filterData.key === 'string' 
                    && this.filterData.key.split(' ').length === 1 
                        ? this.filterData.key.toLowerCase() 
                        : '';
            } 
        }
    }
</script>

<style lang="scss">  
    label {
        margin-bottom:0;
        position:relative;
        input {
            position: relative;
            width: 1rem;
            height: 1rem;
        }
        div {
            font-size:1rem;
            display: inline-block;
        }
        .badge-facet-count {
            padding: .15rem .375rem .125rem;
            border-radius: 10rem;
            margin: 0 0 0 .125rem;
            font-weight:400;
            letter-spacing:.075rem;
            vertical-align:top;
        }    
    }
    .privaturkunde div::before,
    .herrscherurkunde div::before,
    .currently_on_display div::before {
        height: 1.5rem;
        width: 1.5rem;
        padding-right:.25rem;
    }
    .privaturkunde div::before {
        content:url(/img/dot-privaturkunde.svg);
    }
    .herrscherurkunde div::before {
        content:url(/img/dot-herrscherurkunde.svg);
    }
    .currently_on_display div::before {
        content:url(/img/dot-on-display.svg);
    }
</style>